import { PaymentOrderItemData } from '../../order-confirmation/order-completion.interface';
import { UserOrderDetails } from '../../order-history/order-history.interface';
import { PROFESSIONAL } from '../../../common/utils/util';
import { OfferTypeChecker } from '../../../common/utils/offer-type-util';

export type OfferTypeObject = {
  offerType?: string;
  businessUnit?: string;
};

/**
 * Checks if the order is an MHP order.
 *
 * @param orderItems
 */
export function isMhpOrder(orderItems: PaymentOrderItemData[]): boolean {
  return orderItems.some((orderItem) => isMhpEbook(orderItem) || isMhpPhysical(orderItem));
}

/**
 * Checks if the order item is and MHP ebook product.
 *
 * @param orderItem
 */
export function isMhpEbook(orderItem: PaymentOrderItemData | UserOrderDetails | OfferTypeObject): boolean {
  return OfferTypeChecker.isMhpEbook(orderItem?.offerType);
}

/**
 * Checks if the order item is and MHP physical product.
 *
 * @param orderItem
 */
export function isMhpPhysical(orderItem: PaymentOrderItemData | OfferTypeObject): boolean {
  return orderItem?.businessUnit === PROFESSIONAL && OfferTypeChecker.isMhpPrint(orderItem?.offerType);
}
